export { default } from './Soliditet';
